import { CSSProperties } from 'react';
import CustomTooltip from '../CustomTooltip';
import useChipStyles from './Chip.styles';

interface Props {
	id: string;
	label: number | string;
	style?: CSSProperties;
	tooltip: string;
}

const Chip: React.FC<Props> = ({ id, label, style, tooltip }) => {
	const classes = useChipStyles();

	return (
		<CustomTooltip title={tooltip}>
			<div className={classes.root} id={id} style={style}>
				{label}
			</div>
		</CustomTooltip>
	);
};

export default Chip;
